import Layout from './Layout';
import LayoutSection from './LayoutSection';

Layout.Section = LayoutSection;

export {
  Layout
};
